import { Barbell, Lightning, Flame } from "@phosphor-icons/react";

export default function SportAnalysis({ sports }) {
  if (!sports || !sports.length) return null;
  const bestEff = sports.reduce((a, b) => ((b.kcal_per_min ?? -1) > (a?.kcal_per_min ?? -1) ? b : a), null);
  const bestStrain = sports.reduce((a, b) => (b.avg_strain > (a?.avg_strain ?? -1) ? b : a), null);
  return (
    <div className="glass-card p-5" data-testid="sport-analysis">
      <div className="flex items-center gap-2 mb-1">
        <Barbell size={18} weight="fill" className="text-primary" />
        <h3 className="text-sm font-semibold">Анализ по видам спорта</h3>
      </div>
      <p className="text-xs text-muted-foreground mb-4">
        {bestEff?.kcal_per_min != null && <>Самый энергозатратный — <span className="text-[#ffea00] font-semibold">{bestEff.sport}</span> ({bestEff.kcal_per_min} ккал/мин). </>}
        {bestStrain && <>Самая высокая нагрузка в среднем — <span className="text-[#0084ff] font-semibold">{bestStrain.sport}</span> ({bestStrain.avg_strain}).</>}
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {sports.map((s) => (
          <div key={s.sport} className="rounded-md bg-secondary/40 border border-border/40 p-4" data-testid={`sport-card-${s.sport}`}>
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-semibold">{s.sport}</span>
              <span className="text-[10px] text-muted-foreground num">{s.count} трен.</span>
            </div>
            <div className="space-y-1 text-xs">
              <div className="flex justify-between"><span className="text-muted-foreground flex items-center gap-1"><Lightning size={11} className="text-[#0084ff]" />Ср. нагрузка</span><span className="num font-semibold">{s.avg_strain}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Ср. длительность</span><span className="num font-semibold">{s.avg_duration_min != null ? `${s.avg_duration_min} мин` : "—"}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground flex items-center gap-1"><Flame size={11} className="text-[#ffea00]" />Ккал / интенсивность</span><span className="num font-semibold">{s.avg_kcal ?? "—"}{s.kcal_per_min != null ? ` · ${s.kcal_per_min}/мин` : ""}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Ср. пульс</span><span className="num font-semibold">{s.avg_hr != null ? `${s.avg_hr} уд/мин` : "—"}</span></div>
              {s.hi_pct != null && <div className="flex justify-between"><span className="text-muted-foreground">Время в зонах 4–5</span><span className="num font-semibold">{s.hi_pct}%</span></div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
